import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {AppStore, AggregateStore} from 'js/stores'; // singleton stores
import styles from 'css/screens/phaseresult.css';

@observer
/**
 * chart
 */
export default class Chart extends Component {
  /**
   * constructor
   */
  constructor() {
    super();

    this.chart = {
      pc: {
        balloon: {
          width: 172,
        },
        min: 68,
        max: 958,
        phase: {
          4: { // phaseId
            bottom: 196, left: 68, right: 267, top: 226,
          },
          3: {bottom: 234, left: 268, right: 495, top: 284},
          2: {bottom: 285, left: 496, right: 736, top: 319},
          1: {bottom: 320, left: 737, right: 958, top: 396},
        },
      },
      sp: {
        balloon: {
          width: 104,
        },
        min: 6,
        max: 340,
        phase: {
          4: {bottom: 90, left: 6, right: 81, top: 101},
          3: {bottom: 102, left: 82, right: 166, top: 122},
          2: {bottom: 123, left: 167, right: 256, top: 136},
          1: {bottom: 137, left: 257, right: 340, top: 164},
        },
      },
    };
  }

  /**
   * calc position
   * @param {string} type
   * @return {object}
   */
  calcPosition(type) {
    const position = {
      left: 0,
      bottom: 0,
    };

    const linechart = AppStore.selectLinechart;
    const phase = AppStore.selectPhaseFromId(AggregateStore.phaseId);

    if (!phase.id || 0 == linechart.blockRange) {
      // 必要情報が揃っていない場合は非表示
      position.display = 'none';
      return position;
    }

    const count = AggregateStore.countYes;
    const range = linechart.blockRange;
    const block = this.chart[type].phase[phase.id];
    const lps = (block.right - block.left) / range; // left per score
    const bps = (block.bottom - block.top) / range; // bottom per score
    const score = count - phase.range;

    position.left = block.left + (lps * score);
    position.bottom = block.bottom - (bps * score);

    return position;
  }

  /**
   * get balloon adjust margin
   * @param {string} type
   * @param {number} left
   * @return {number}
   */
  getBalloonAdjustMargin(type, left) {
    const balloonHalf = this.chart[type].balloon.width / 2;
    const leftMax = this.chart[type].max;
    const leftMin = this.chart[type].min;
    let adjust = 0;

    if (leftMax < (left + balloonHalf)) {
      adjust = leftMax - (left + balloonHalf);

      const point = ('pc' == type ? 15 : 5);

      if (adjust < (balloonHalf + point)) {
        adjust += point;
      }

      if (0 < adjust) {
        adjust = 0;
      }
    } else if (leftMin > (left - balloonHalf)) {
      adjust = leftMin - (left - balloonHalf);

      const point = ('pc' == type ? 20 : 15);

      if (adjust < (balloonHalf + point)) {
        adjust -= point;
      }

      if (0 > adjust) {
        adjust = 0;
      }
    }

    return adjust;
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const pcPointStyles = this.calcPosition('pc');
    const pcBalloonStyles = {
      marginLeft: this.getBalloonAdjustMargin('pc', pcPointStyles.left),
    };

    const spPointStyles = this.calcPosition('sp');
    const spBalloonStyles = {
      marginLeft: this.getBalloonAdjustMargin('sp', spPointStyles.left),
    };

    return (
      <div className={styles.chart}>
        <div className={styles.pc}>
          <a style={pcPointStyles}>
            <span style={pcBalloonStyles}>御社の現在フェーズ</span>
          </a>
        </div>
        <div className={styles.sp}>
          <div className={styles.chartWrap}>
            <div>
              <a style={spPointStyles}>
                <span style={spBalloonStyles}>御社の現在フェーズ</span>
              </a>
            </div>
          </div>
          <ul>
            <li>
              <h4>
                <p>立ち上げフェーズ</p>
                市場創造のPR活動を行う際の基本的な土台を作る
              </h4>
              注力事項：新習慣や新カテゴリを規定する市場創造記号の開発
            </li>
            <li>
              <h4>
                <p>認知フェーズ</p>
                新習慣や新カテゴリの認知を図っていくフェーズ
              </h4>
              注力事項：多様な手法による積極的な情報発信
            </li>
            <li>
              <h4>
                <p>コト訴求フェーズ</p>
                企業・商品・サービスの利用シーンやベネフィットを伝える
              </h4>
              注力事項：新習慣や新カテゴリを規定する市場創造記号の開発
            </li>
            <li>
              <h4>
                <p>習慣化フェーズ</p>
                利用シーンやベネフィットを習慣化
              </h4>
              注力事項：習慣化・愛用化するためのオンライン/オフライン施策の統合化
            </li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/phaseresult/chart.js